import { Component, effect, inject, OnDestroy } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { AppButtonsComponent } from "@shared/ui/app-buttons/app-buttons";
import { TranslatePipe } from '@ngx-translate/core';
import { CandidateDashboardComponent } from "app/features/private/candidate/dashboard/dashboard";
import { ROUTES } from '@shared/constants/routes';
import { BUTTON_CLASS_TYPES } from '@constants/app-button.constants';
import { EmployerService } from '@shared/services/employer.service';

@Component({
  selector: 'app-employee-management-layout',
  imports: [AppButtonsComponent, TranslatePipe, CandidateDashboardComponent],
  templateUrl: './employee-management-layout.html',
  styleUrls: []
})
export class EmployeeManagementLayout implements OnDestroy {
  protected readonly BUTTON_CLASS_TYPES = BUTTON_CLASS_TYPES;
  employeeId = '';

  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly employerService = inject(EmployerService);

  private readonly params = toSignal(this.activatedRoute.params);

  constructor() {
    effect(() => {
      const p = this.params();
      this.employeeId = p?.['employeeId'] ?? '';
      this.employerService.setEmployeeContext(this.employeeId, {});
    });
  }

  ngOnDestroy(): void {
    this.employerService.setEmployeeContext(null, null);
  }

  goBack() {
    this.router.navigate([ROUTES.EMPLOYER_LOGGED_HOME, ROUTES.DASHBOARD, ROUTES.EMPLOYEES_MANAGEMENT]);
  }
}
